/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_ai_blue': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" d="M6.82.212c2.495 0 4.513 2.055 4.513 4.595a4.6 4.6 0 0 1-2.578 4.149v2.893H4.242v-1.79h-.645c-.71 0-1.29-.591-1.29-1.313L2.25 6.814l-1.259.01A.328.328 0 0 1 .732 6.3L2.25 4.24C2.365 1.811 4.403.212 6.82.212zm.795.74h-.932a.268.268 0 0 0-.271.225l-.094.58c-.161.065-.305.156-.444.258L5.885 2l-.565-.21a.275.275 0 0 0-.339.119l-.465.784a.266.266 0 0 0 .066.343l.471.366.012-.016c-.012.08-.028.166-.028.252s.016.172.028.258l-.012-.016-.47.365a.266.266 0 0 0-.067.344l.465.784a.28.28 0 0 0 .339.118l.56-.21-.006-.021c.139.102.283.193.444.258l.094.574c.016.135.133.231.271.231h.932a.268.268 0 0 0 .272-.225l.094-.58c.16-.065.305-.156.443-.258l-.01.016.56.21c.127.048.27 0 .337-.119l.466-.784a.266.266 0 0 0-.066-.344l-.472-.365-.01.016c.01-.086.027-.171.027-.257s-.017-.172-.028-.258l.011.016.472-.365a.266.266 0 0 0 .066-.344l-.466-.784a.28.28 0 0 0-.338-.118l-.56.21.011.015a2.515 2.515 0 0 0-.443-.247l-.094-.58a.268.268 0 0 0-.272-.225zm-.469 1.79a.895.895 0 0 1 0 1.79.895.895 0 0 1 0-1.79z" _fill="#086CE8" fill-rule="evenodd"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_ai_blue.js